import React from 'react';
import './index.css';

class Radio extends React.Component {
    constructor(props) {
        super();
    }

    handleChange = () => {
        const p = this.props;
        p.onChange(p.orientationName, p.value);
    };

    render() {
        const t = this;
        const p = t.props;

        const cls_checked = p[p.name] === p.value ? 'checked' : '';

        return(
            <div className={'radio_wrapper ' + cls_checked} onClick={t.handleChange}>
                <div className="radio_box"> </div>
                <div className="radio_label">{p.label}</div>
            </div>
        )
    }
}

export default Radio;